import { makeStyles } from '@material-ui/core';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { vSpacing } from 'src/common/helpers/config';
import { calculateHeight, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface TopAreaButtonProps {
  textSize: SizeType;
  isMiddle?: boolean;
  selected?: boolean;
}

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => {
  return {
    buttonContainer: ({ textSize, isMiddle, selected }: TopAreaButtonProps) => {
      const isActive = isMiddle && selected;
      return {
        position: 'relative',
        padding: 0,
        border: 'none !important',
        '& svg': {
          height: CashierPreferencesHelper.sizeMultiplier(textSize) * 24,
          width: CashierPreferencesHelper.sizeMultiplier(textSize) * 24,
          position: 'relative',
          zIndex: isActive ? 1302 : 1,
        },
        '&::before': {
          content: '""',
          display: isActive ? 'block' : 'none',
          height: `calc(100% + ${vSpacing})`,
          width: '100%',
          position: 'absolute',
          top: 0,
          left: -3,
          border: `3px solid ${theme.palette.secondary.main}`,
          borderBottom: 'none',
          borderRadius: '2px 2px 0 0',
        },
        '&::after': {
          content: '""',
          display: isActive ? 'block' : 'none',
          height: `calc(100% + ${vSpacing} + 6px)`,
          width: '100%',
          position: 'absolute',
          top: 3,
          left: 0,
          background: themeColor.white,
          zIndex: isActive ? 1301 : 1,
        },
        '&[disabled]': {
          opacity: '0.4',
        },
      };
    },
    badge: {
      height: calculateHeight(26, 768).stringValue,
      width: calculateHeight(26, 768).stringValue,
      borderRadius: '50%',
      transform: 'scale(1) translate(-25%, -25%)',
      fontSize: vh(2.08),
      fontWeight: 500,
      letterSpacing: 0.5,
      '@media(width:1024px) and (height:768px)': {
        transform: 'scale(1) translate(-12%, -25%)',
      },
      '@media(width:1600px) and (height:1200px)': {
        transform: 'scale(1) translate(-12%, -25%)',
      },
    },
    modalAnchor: {
      position: 'absolute',
      bottom: 0,
      left: '50%',
      height: 1,
      width: 1,
    },
  };
});
